/**
 * Bolsa.Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EnumEstadoMatricula = 0 | 1 | 2 | 3 | 4;

export const EnumEstadoMatricula = {
    NUMBER_0: 0 as EnumEstadoMatricula,
    NUMBER_1: 1 as EnumEstadoMatricula,
    NUMBER_2: 2 as EnumEstadoMatricula,
    NUMBER_3: 3 as EnumEstadoMatricula,
    NUMBER_4: 4 as EnumEstadoMatricula
};

